RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Configuration = RivalIQ.data.CacheLayer.extend({
        name: 'Configuration',
        cacheKeys: [
            'configurationId',
            'curationId',
            'landscapeId'
        ],

        loadData: function (attrs) {
            const curation = attrs.curation;

            const model = curation.buildConfiguration();

            return model.fetch().then(function () {
                return model;
            });
        },

        fetch: function (curation, props, options) {
            const me = this;

            return me.getOrLoad({
                configurationId: props.configurationId,
                curationId: curation.getCurationId(),
                landscapeId: props.landscapeId,
                curation: curation
            }, options);
        },

        clearCacheByCurationId: function (curationId) {
            const me = this;

            me.caches = _.reject(me.caches, function (cache) {
                return curationId === cache.data.attributes.curationId;
            });
        }
    });

    data.configuration = new Configuration();
});
